import { z } from 'zod';
import { parkerExportFilterSchema } from './parker-export.schema';

export const subscriptionExportParametersSchema = z.strictObject({
	filters: z.array(parkerExportFilterSchema).default([]),
	order: z
		.strictObject({
			field: z.string().trim().min(1),
			sort: z.enum(['asc', 'desc']),
		})
		.default({ field: 'createdAt', sort: 'desc' }),
	facilityId: z.string().trim().min(1).optional(),
});

export type SubscriptionExportFilter = z.infer<typeof parkerExportFilterSchema>;
export type SubscriptionExportParameters = z.infer<typeof subscriptionExportParametersSchema>;
